import React, { Children, cloneElement, PureComponent } from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import Responsive from '../responsive/Responsive';
import ConfigContext from '../config-provider/ConfigContext';
const defaultGutter = 0;
export default class Row extends PureComponent {
    constructor() {
        super(...arguments);
        this.renderRow = ([gutter = defaultGutter]) => {
            const { type, justify, align, className, style, children, prefixCls: customizePrefixCls, ...others } = this.props;
            const { getPrefixCls } = this.context;
            const prefixCls = getPrefixCls('row', customizePrefixCls);
            const classes = classNames({
                [prefixCls]: !type,
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-${type}-${justify}`]: type && justify,
                [`${prefixCls}-${type}-${align}`]: type && align,
            }, className);
            const rowStyle = gutter > 0
                ? {
                    marginLeft: gutter / -2,
                    marginRight: gutter / -2,
                    ...style,
                }
                : style;
            const cols = Children.map(children, (col) => {
                if (!col) {
                    return null;
                }
                if (col.props && gutter > 0) {
                    return cloneElement(col, {
                        style: {
                            paddingLeft: gutter / 2,
                            paddingRight: gutter / 2,
                            ...col.props.style,
                        },
                    });
                }
                return col;
            });
            const otherProps = { ...others };
            delete otherProps.gutter;
            return (React.createElement("div", Object.assign({}, omit(otherProps, ['rowIndex', 'colIndex']), { className: classes, style: rowStyle }), cols));
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { gutter } = this.props;
        return React.createElement(Responsive, { items: [gutter] }, this.renderRow);
    }
}
Row.displayName = 'Row';
Row.defaultProps = {
    gutter: defaultGutter,
};
